class SwCartDrawer {
    constructor() {
        this.drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        document.addEventListener('click', this.addSubscription.bind(this));
        document.addEventListener('change', this.changeSubscription.bind(this));
        document.addEventListener('click', this.handleRemoveAutoRefill.bind(this));
        document.addEventListener('click', this.handleRemoveSubscriptionFromItem.bind(this)); // Add this line
    }

    async addSubscription(e) {
        const subscribe = e.target.closest('.sw-cart-drawer-subscribe');

        if (!subscribe) {
            return;
        }

        this.loading(subscribe);

        const response = await this.request({
            'line': subscribe.getAttribute('data-sw-line') ?? 0,
            'selling_plan': subscribe.getAttribute('data-sw-plan') ?? 0
        });
        await this.render(response);
    }

    async changeSubscription(e) {
        e.preventDefault();
        e.stopPropagation();

        const dropdown = e.target.closest('select[name="sw-cart-drawer-selling-plan"]');

        if (!dropdown) {
            return;
        }

        this.loading(dropdown);

        // Get the cart item that contains this dropdown
        const cartItem = dropdown.closest('.cart-item');

        // Remove the existing auto-refill item before updating
        if (cartItem) {
            const existingRefill = cartItem.nextElementSibling;
            if (existingRefill?.classList.contains('auto-refill-item')) {
                existingRefill.remove();
            }
        }

        const response = await this.request({
            'line': dropdown.getAttribute('data-sw-line') ?? 0,
            'selling_plan': dropdown.value ?? 0
        });
        await this.render(response);
    }

    async handleRemoveAutoRefill(e) {
        const removeButton = e.target.closest('.remove-auto-refill');
        
        if (!removeButton) {
            return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        // Find the parent auto-refill item
        const autoRefillItem = removeButton.closest('.auto-refill-item');
        if (!autoRefillItem) {
            return;
        }
        
        // Get the line index from the data attribute
        const lineIndex = autoRefillItem.getAttribute('data-parent-line');
        if (!lineIndex) {
            return;
        }
        
        // Show loading state
        removeButton.setAttribute('data-loading', 'true');
        removeButton.disabled = true;
        
        // Remove the subscription
        await this.removeAutoRefill(lineIndex);
    }

    async handleRemoveSubscriptionFromItem(e) {
        const removeButton = e.target.closest('.remove-subscription-from-item');
        
        if (!removeButton) {
            return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        // Get the line index
        const lineIndex = removeButton.getAttribute('data-sw-line');
        if (!lineIndex) {
            return;
        }
        
        // Show loading state
        removeButton.textContent = 'Removing...';
        removeButton.disabled = true;
        
        // Remove the subscription (convert to one-time purchase)
        const response = await this.request({
            'line': lineIndex,
            'selling_plan': null
        });
        await this.render(response);
    }

    async removeAutoRefill(lineIndex) {
        const response = await this.request({
            'line': lineIndex,
            'selling_plan': null
        });
        await this.render(response);
    }

    async request(formData) {
        return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    async getHtml(sectionID) {
        let url = `${window.location.pathname}?section_id=${sectionID}`;
        const response = await fetch(url);
        return await response.text();
    }

    async render(response) {
        let drawer = await this.getHtml('cart-drawer');
        let icon = await this.getHtml('cart-icon-bubble');

        response.sections = [];
        response.sections['cart-drawer'] = drawer;
        response.sections['cart-icon-bubble'] = icon;

        setTimeout(() => {
            this.drawer.renderContents(response);
        }, 100);
    }

    loading(element) {
        const spinner = element.closest('.cart-item').querySelector('.loading__spinner');
        if (!spinner) {
            return
        }

        spinner.classList.remove('hidden');
    }
}

window.addEventListener('DOMContentLoaded', () => {
    new SwCartDrawer();
});

// Refill product mappings
const refillMappings = {
  'signature-shampoo-wonder': 'signature-shampoo-refill',
  'signature-conditioner': 'signature-conditioner-refill',
  'signature-shampoo-conditioner-set': 'signature-set-refill',
  'signature-shampoo-copy': 'signature-shampoo-refill-copy',
  'signature-sets': 'signature-set-refill',
  'signature-conditioner-copy': 'signature-conditioner-refill-copy',
  'signature-conditioner-copy-1': 'signature-conditioner-refill',
  'color-boost-shampoo': 'color-boost-conditioner-refill',
  'smooth-shine-shampoo': 'smooth-shine-shampoo-refill-1',
  'color-boost-conditioner': 'color-boost-conditioner-refill',
  'enrich-hydrate-conditioner': 'enrich-hydrate-conditioner-refill',
  'smooth-shine-conditioner': 'smooth-shine-conditioner-refill',
  'volume-bounce-conditioner': 'volume-bounce-conditioner-refill',
  'd-kerabind-11-magic-repair-mask': 'd-kerabind-11-magic-repair-mask-refill',
  'b-cap-magic-growth-hair-scalp-mask': 'b-cap-magic-growth-hair-scalp-mask-refill',
  'peptoflex-13-magic-repair-serum': 'peptoflex-13-magic-repair-serum-refill',
  'clarify-and-purify-shampoo': 'clarify-and-purify-shampoo-refill',
  'revive-grow-shampoo': 'revive-grow-shampoo-refill',
  'volume-bounce-shampoo': 'volume-bounce-shampoo-refill',
  'magic-perfecting-serum-insider-access': 'perfecting-serum-refill',
  'magic-perfecting-serum-copy': 'perfecting-serum-refill',
  'restorative-magic-serum': 'perfecting-serum-refill',
  'magic-perfecting-serum': 'perfecting-serum-refill',
};

// Parent variants for which auto-refill should not be rendered.
// Keep IDs as strings to avoid type mismatch during comparison.
const refillExcludedVariantIds = new Set([
  '48241192435927'
]);

const refillProductDataCache = new Map();

// Fetch refill product data
async function getRefillProductData(handle) {
  if (refillProductDataCache.has(handle)) {
    return refillProductDataCache.get(handle);
  }

  const refillProductPromise = (async () => {
    const response = await fetch(`/products/${handle}.js`);
    if (response.ok) {
      return await response.json();
    }
    return null;
  })().catch((error) => {
    console.error('Error fetching refill product:', error);
    return null;
  });

  refillProductDataCache.set(handle, refillProductPromise);

  return refillProductPromise;
}

function getSellingPlanFrequency(label) {
  const normalizedLabel = String(label || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const frequencyMatch = normalizedLabel.match(
    /every\s+(?:\d+\s+)?(?:day|days|week|weeks|month|months|year|years)/
  );

  return frequencyMatch?.[0] || normalizedLabel;
}

function getFixedSellingPlanPrice(sellingPlan) {
  const fixedPriceAdjustment = sellingPlan?.price_adjustments?.find((adjustment) => {
    const value = Number(adjustment?.value);
    return adjustment?.value_type === 'price' && Number.isFinite(value);
  });

  return fixedPriceAdjustment ? Number(fixedPriceAdjustment.value) : null;
}

function getRefillSellingPlanPrice(refillProduct, deliveryFrequency) {
  const sellingPlans = refillProduct?.selling_plan_groups?.flatMap((group) => group.selling_plans || []) || [];

  if (!sellingPlans.length) {
    return null;
  }

  const selectedFrequency = getSellingPlanFrequency(deliveryFrequency);
  const matchingPlan = sellingPlans.find((sellingPlan) => (
    getSellingPlanFrequency(sellingPlan.name) === selectedFrequency
  ));

  return getFixedSellingPlanPrice(matchingPlan) ?? getFixedSellingPlanPrice(sellingPlans[0]);
}

function scheduleAddRefillSections() {
  if (window.addRefillSectionsFrame) {
    return;
  }

  const run = () => {
    window.addRefillSectionsFrame = null;
    addRefillSections().catch((error) => {
      console.error('Error adding refill sections:', error);
    });
  };

  if (typeof window.requestAnimationFrame === 'function') {
    window.addRefillSectionsFrame = window.requestAnimationFrame(run);
    return;
  }

  window.addRefillSectionsFrame = window.setTimeout(run, 0);
}

function patchCartElementRefillRender(elementName) {
  const cartElement = window.customElements?.get(elementName);

  if (!cartElement?.prototype?.renderContents || cartElement.prototype.renderContents.__swAutoRefillPatched) {
    return;
  }

  const originalRenderContents = cartElement.prototype.renderContents;

  cartElement.prototype.renderContents = function(...args) {
    const result = originalRenderContents.apply(this, args);
    scheduleAddRefillSections();
    return result;
  };

  cartElement.prototype.renderContents.__swAutoRefillPatched = true;
}

['cart-drawer', 'cart-notification'].forEach((elementName) => {
  if (window.customElements?.whenDefined) {
    window.customElements.whenDefined(elementName).then(() => {
      patchCartElementRefillRender(elementName);
    });
    return;
  }

  patchCartElementRefillRender(elementName);
});

function shouldScheduleRefillForMutation(mutation) {
  const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes];

  return changedNodes.some((node) => {
    if (!(node instanceof Element)) {
      return false;
    }

    return node.matches?.('cart-drawer-items, .drawer__cart-items-wrapper, .cart-items, .cart-item, .drawer__footer') ||
      node.querySelector?.('cart-drawer-items, .drawer__cart-items-wrapper, .cart-items, .cart-item, .drawer__footer');
  });
}

function observeCartDrawerRefillChanges() {
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer || cartDrawer.__swAutoRefillObserver) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some(shouldScheduleRefillForMutation)) {
      scheduleAddRefillSections();
    }
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });

  cartDrawer.__swAutoRefillObserver = observer;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeCartDrawerRefillChanges, { once: true });
} else {
  observeCartDrawerRefillChanges();
}

// Add refill sections for all subscription items
async function addRefillSections() {
  // Prevent concurrent executions
  if (window.addingRefillSection) {
    return;
  }
  window.addingRefillSection = true;

  try {
  
  // Find all cart items with subscriptions
  const cartItems = document.querySelectorAll('.cart-item');
  
  for (const cartItem of cartItems) {
    // Skip if this item already has a refill section
    if (cartItem.nextElementSibling?.classList.contains('auto-refill-item')) {
      continue;
    }
    
    // Check if this cart item has a subscription
    const hasSubscription = cartItem.querySelector('.product-option')?.textContent?.toLowerCase().includes('refills deliver') ||
                           cartItem.querySelector('.sw-cart-drawer-selling-plan-change')?.textContent?.toLowerCase().includes('refills deliver') ||
                           cartItem.querySelector('[name="sw-cart-drawer-selling-plan"]') !== null ||
                           cartItem.textContent?.toLowerCase().includes('refills deliver') ||
                           cartItem.textContent?.toLowerCase().includes('every month') ||
                           cartItem.textContent?.toLowerCase().includes('every week');
    
    if (!hasSubscription) {
      continue;
    }
    
    // Get product handle from this cart item
    const productLink = cartItem.querySelector('.cart-item__name');
    if (!productLink?.href) {
      continue;
    }
    
    const urlParts = productLink.href.split('/products/');
    const parentHandle = urlParts[1]?.split('?')[0];
    const parentVariantId = cartItem
      .querySelector('.sw-cart-drawer-item-remove [data-variant-id]')
      ?.getAttribute('data-variant-id');
    const isExcludedVariant = parentVariantId
      ? refillExcludedVariantIds.has(String(parentVariantId))
      : false;
    const refillHandle = parentHandle && !isExcludedVariant
      ? refillMappings[parentHandle]
      : null;
    
    if (!refillHandle) {
      continue;
    }
    
    // Fetch refill product data
    const refillProduct = await getRefillProductData(refillHandle);
    if (!cartItem.isConnected) {
      continue;
    }
    
    // Get delivery frequency - copy the text from the parent item's display
let deliveryFrequency = 'Delivers every month'; // fallback

// Try to get it from the visible text in the product options
const productOptions = cartItem.querySelectorAll('.product-option dd');
productOptions.forEach(dd => {
  const text = dd.textContent.trim().toLowerCase();
  if (text.includes('deliver') || text.includes('refill')) {
    deliveryFrequency = dd.textContent.trim();
  }
});

// If not found, try the dropdown's selected option
if (deliveryFrequency === 'Delivers every month') {
  const dropdown = cartItem.querySelector('.sw-cart-drawer-selling-plan-change');
  if (dropdown && dropdown.selectedIndex >= 0) {
    deliveryFrequency = dropdown.options[dropdown.selectedIndex].text;
  }
}

console.log('Final delivery frequency:', deliveryFrequency); // Debug
    
    // Clean the title
    let productTitle = refillProduct?.title || 'Product Refill';
    if (productTitle.includes('oz') || productTitle.includes('washes')) {
      productTitle = productTitle.split(' ').slice(0, 3).join(' ');
    }
    
    const productImage = refillProduct?.featured_image || '';
    const refill_product_price = refillProduct?.price ?? 3000;
    const productPrice = (refill_product_price / 100).toFixed(2);

    const basePriceCents = refill_product_price;
    const refillSellingPlanPriceCents = getRefillSellingPlanPrice(refillProduct, deliveryFrequency);
    const fallbackDiscountedPriceCents = refillProduct?.price
      ? Math.round((basePriceCents * 0.85) / 100) * 100
      : 2700;
    const discountedPriceCents = refillSellingPlanPriceCents ?? fallbackDiscountedPriceCents;
    const discountedPrice = (discountedPriceCents / 100).toFixed(2);
    const discountPercentPriceCents = Math.round(basePriceCents * 0.85);
    const discountPercent = Math.round(
      (1 - discountPercentPriceCents / basePriceCents) * 100
    );

    // Get the line index for this cart item
    const lineIndex = cartItem.querySelector('[data-index]')?.getAttribute('data-index') || '';

    const refillHTML = `
<div class="auto-refill-item" data-parent-line="${lineIndex}" style="">
 <div class="auto-refill-item-group-title">Auto-Refill Items:</div>
  <div class="auto-refill-item__wrapper">
    <div style="width: 13.5rem; display: flex; flex-direction: column; flex-shrink: 0;">
      <style>
        @media (min-width: 750px) {
          .auto-refill-item[data-parent-line="${lineIndex}"] > div > div:first-child {
            width: 22rem !important;
          }
          .auto-refill-item[data-parent-line="${lineIndex}"] > div > div:first-child > div:last-child {
            width: 13.7rem !important;
            height: 13rem !important;
          }
        }
      </style> 
      <div class="auto-refill-item-image">
        ${productImage ? `
          <img 
            src="${productImage}" 
            alt="${productTitle}"
            style="width: 100%; height: 100%; object-fit: cover;"
          />
        ` : '<div style="width: 100%; height: 100%; background: #e0e0e0;"></div>'}
      </div>
    </div>
    
    <div style="flex: 1; min-width: 0;">
      <div class="auto-refill-item-title">
        <h4>
          ${productTitle}
        </h4>
        <button class="cart-remove-button remove-auto-refill">
       <svg  aria-hidden="true" focusable="false" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.1826 0.100388C10.2526 0.100425 10.322 0.113664 10.3867 0.140427C10.4516 0.167289 10.5109 0.207002 10.5605 0.256638C10.61 0.306099 10.649 0.364925 10.6758 0.429489C10.7026 0.494342 10.7168 0.564372 10.7168 0.634567C10.7168 0.704671 10.7026 0.77389 10.6758 0.838669C10.6489 0.903467 10.6101 0.962887 10.5605 1.0125L6.16309 5.408L10.5605 9.80449C10.61 9.85398 10.649 9.91275 10.6758 9.97734C10.7026 10.0422 10.7168 10.1122 10.7168 10.1824C10.7168 10.2525 10.7026 10.3218 10.6758 10.3865C10.6489 10.4514 10.6102 10.5107 10.5605 10.5603C10.5109 10.61 10.4516 10.6487 10.3867 10.6756C10.322 10.7024 10.2527 10.7166 10.1826 10.7166C10.1124 10.7166 10.0424 10.7024 9.97754 10.6756C9.91295 10.6488 9.85418 10.6098 9.80469 10.5603L5.4082 6.16289L1.0127 10.5603C0.963085 10.6099 0.903666 10.6487 0.838867 10.6756C0.774088 10.7024 0.704869 10.7166 0.634766 10.7166C0.564571 10.7166 0.49454 10.7024 0.429688 10.6756C0.365123 10.6488 0.306297 10.6098 0.256836 10.5603C0.2072 10.5107 0.167488 10.4514 0.140625 10.3865C0.113863 10.3218 0.100623 10.2524 0.100586 10.1824C0.100586 10.1122 0.113762 10.0422 0.140625 9.97734C0.167464 9.91259 0.207286 9.85407 0.256836 9.80449L4.65332 5.408L0.256836 1.0125C0.2072 0.962861 0.167488 0.903521 0.140625 0.838669C0.113888 0.773956 0.100591 0.704589 0.100586 0.634567C0.100586 0.564372 0.113762 0.494341 0.140625 0.429489C0.167484 0.364763 0.207282 0.306192 0.256836 0.256638C0.30639 0.207083 0.364962 0.167286 0.429688 0.140427C0.49454 0.113564 0.56457 0.100388 0.634766 0.100388C0.704787 0.100393 0.774155 0.11369 0.838867 0.140427C0.903719 0.167289 0.963059 0.207002 1.0127 0.256638L5.4082 4.65312L9.80469 0.256638C9.85427 0.207088 9.91278 0.167266 9.97754 0.140427C10.0424 0.113564 10.1124 0.100388 10.1826 0.100388Z" fill="#2D2D2D" stroke="black" stroke-width="0.2"/>
</svg>
      </button>
      </div>     
      
      <div class="cart-item__price-wrapper">
        <div class="cart-item__price-group">
            <s class="cart-item__old-price">$${productPrice}</s>
            <span class="cart-item__final-price">$${discountedPrice}</span>
        </div>
        <span class="cart-item__savings">Save ${discountPercent}%</span>
        <div class="loading__spinner hidden">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>
      <div class="auto-refill-selling-plans">
            <div class="auto-refill-selling-plans-target"></div>
            <p class="auto-refill-selling-plans-description">cancel, pause, skip, or modify any time</p>
      </div>
    </div>
  </div>
</div>
`;
    // Insert the refill item directly after the parent cart item
    cartItem.insertAdjacentHTML('afterend', refillHTML);
    const autoRefillItem = cartItem.nextElementSibling;
    if (!autoRefillItem || !autoRefillItem.classList.contains('auto-refill-item')) {
      continue;
    }
    const target = autoRefillItem.querySelector('.auto-refill-selling-plans-target');
    if (!target) continue;
    const originalSelect = cartItem.querySelector('.sw-cart-drawer-selling-plan-change');
    if (!originalSelect) continue;
    const cloneSelect = originalSelect.cloneNode(true);
    cloneSelect.removeAttribute('data-sw-line');
    cloneSelect.removeAttribute('id');
    cloneSelect.value = originalSelect.value;
    cloneSelect.style.display = 'block';
    target.appendChild(cloneSelect);

    cloneSelect.addEventListener('change', () => {
      originalSelect.value = cloneSelect.value;
      originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });

  }
  } finally {
    window.addingRefillSection = false;
  }
}

// Check periodically when cart is open (reduced frequency)
setInterval(function() {
  const cartDrawer = document.querySelector('cart-drawer.active, cart-notification.active');
  if (cartDrawer && document.querySelector('.drawer__cart-items-wrapper')) {
    scheduleAddRefillSections();
  }
}, 2000);

// Trigger on cart icon click
document.addEventListener('click', function(e) {
  if (e.target.closest('#cart-icon-bubble, [href*="/cart"]')) {
    scheduleAddRefillSections();
  }
});
